import { render, staticRenderFns } from "./section-header.vue?vue&type=template&id=607ccdca&"
import script from "./section-header.vue?vue&type=script&lang=js&"
export * from "./section-header.vue?vue&type=script&lang=js&"
import style0 from "./section-header.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VideoPlayerPopup: require('/home/martin/web/decentral-art/components/video-player-popup.vue').default})


/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
